import React from 'react';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import TriggerRuleStore from 'stores/triggers/TriggerRuleStore';
import mapValues from 'lodash/mapValues';
import pick from 'lodash/pick';
import Breadcrumbs from 'components/pure/utils/Breadcrumbs';
import TriggerRuleInfoContainer from 'components/triggers/TriggerRuleInfoContainer';
import AuthStore from 'stores/AuthStore';
import TriggerTrendView from 'components/triggers/TriggerTrendView';
import TriggerRealTimeView from 'components/triggers/TriggerRealTimeView';
import TriggerNotificationView from 'components/triggers/TriggerNotificationView';
import {browserHistory} from 'react-router';
import Button from '@material-ui/core/Button';
import './TriggerReadonlyView.styl';
import classNames from 'classnames';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import UserStore from 'stores/UserStore';

@connectToStores
export default class TriggerReadonlyView extends React.Component {
  static getStores() {
    return [TriggerRuleStore];
  }

  static getPropsFromStores(nextProps) {
    if (!nextProps) {
      return {};
    }
    const state = TriggerRuleStore.getState();
    const rule = state.rules.get(nextProps.params.ruleId);
    return {
      rule,
      ...mapValues(pick(state, ['antiRules', 'antiRulesLoading', 'antiRulesErrored']), value =>
        value.get(nextProps.params.ruleId)
      ),
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    const ruleId = this.props.params.ruleId;

    TriggerRuleActions.fetchAntiRules(ruleId);
    await TriggerRuleActions.fetchTriggerRule(ruleId);

    await TriggerRuleActions.fetchTriggerTrends(ruleId);
    TriggerRuleActions.fetchTriggerRuleActions(ruleId);
  }

  render() {
    const {rule} = this.props;
    if (!rule) {
      return null;
    }
    const actions = rule.actions;
    const hasActions = actions && actions.size > 0;
    const trend = rule.trends.first();

    const breadcrumbLinks = [{url: '/admin/actions', name: 'Smart Alerts'}, {name: 'Rule Detail'}];

    const creator = UserStore.getState().users.get(rule.userId);
    const canEdit = rule.rulePermissions.EDIT !== undefined;

    return (
      <div className={classNames(['triggers-page', 'triggers-readonly-view'])}>
        <div className="top-nav">
          <Breadcrumbs links={breadcrumbLinks} />
          {canEdit && (
            <Button
              variant="contained"
              color="primary"
              className="ev-button"
              onClick={() => browserHistory.push(`/admin/actions/${rule.id}/edit`)}>
              Edit Rule
            </Button>
          )}
          {!canEdit && (
            <GenericTooltip
              tooltip={
                <p>
                  This trigger is privately administered
                  {creator
                    ? ` by ${creator.getFullName()}. Please contact them if you need to be able to edit it.`
                    : '.'}
                </p>
              }>
              <Button variant="contained" color="primary" className="ev-button" disabled>
                Edit Rule
              </Button>
            </GenericTooltip>
          )}
        </div>
        <TriggerRuleInfoContainer isDetails rule={rule} user={AuthStore.getState().user} readonly />
        {trend && <TriggerTrendView trend={trend} readonly />}
        {!trend && hasActions && <TriggerRealTimeView />}
        <TriggerNotificationView rule={rule} trend={trend} actions={actions.toList()} readonly />
      </div>
    );
  }
}
